var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center py-4" },
    [
      _c(
        "vue-content-loading",
        {
          attrs: {
            height: 125,
            width: 320,
            speed: 2,
            "primary-color": "#f3f3f3",
            "secondary-color": "#ecebeb",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0",
              y: "0",
              rx: "3",
              ry: "3",
              width: "320",
              height: "125",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }